import { render, staticRenderFns } from "./batch-delete-data.vue?vue&type=template&id=4a39286c&"
import script from "./batch-delete-data.vue?vue&type=script&lang=ts&"
export * from "./batch-delete-data.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports